module.exports = __webpack_public_path__ + "img/arrow-bigger.e7ecc5dc.svg";